const FAQ_ITEMS = [
  {
    q: '新新漫画是免费的吗？',
    a: '是的，新新漫画上的所有作品均可免费阅读，无需会员付费。我们致力于为漫迷提供最纯粹的阅读体验，全站无弹窗广告、无付费墙，让你安心享受每一话。',
  },
  {
    q: '新新漫画支持哪些漫画类型？',
    a: '新新漫画覆盖韩漫、日漫、国漫三大品类，按纯爱、奇幻、热血、悬疑、搞笑、都市、古风、玄幻、校园、治愈等十余种类型精细化分类，无论你喜欢什么风格都能快速找到心仪之作。',
  },
  {
    q: '多久更新一次漫画内容？',
    a: '我们每日追踪 200+ 话更新，热门作品几乎与韩国、日本、国内连载同步。更新后首页和分类页会实时刷新，你收藏的作品更新时也会有醒目提示，绝不会错过最新章节。',
  },
  {
    q: '可以在手机上阅读吗？',
    a: '当然可以！新新漫画完美适配手机、平板和电脑。在移动端还有专属的阅读模式，支持竖屏滑动阅读、夜间模式和字号调节，随时随地畅读漫画。',
  },
  {
    q: '如何收藏喜欢的漫画？',
    a: '每部漫画详情页都有"加入书架"按钮，点击即可收藏。收藏后可在个人书架的"我的收藏"中统一管理，阅读进度自动同步，下次打开直接续读。',
  },
  {
    q: '可以推荐漫画给朋友吗？',
    a: '每部作品页面都有分享功能，可以一键分享给好友。当然，最直接的方式是把新新漫画的首页地址发给朋友，让他们自己来探索这个漫画宝库！',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <h2 className="text-[22px] md:text-[28px] font-heading font-bold text-foreground-950 text-center mb-3">
          常见问题
        </h2>
        <p className="text-[14px] text-foreground-500 text-center mb-10">
          关于新新漫画，你可能想了解的事情
        </p>
        <div className="max-w-[800px] mx-auto space-y-3">
          {FAQ_ITEMS.map((item) => (
            <div
              key={item.q}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <h3 className="text-[15px] font-bold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {item.q}
              </h3>
              <p className="text-[14px] leading-relaxed text-foreground-600 pl-6">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}